export default __webpack_public_path__ + "static/dominoes-467205961a90c2cc7a6863692b5d3bfa.png";